import { LangUri } from '@catawiki/runtime-toolkit';

export const langUri = LangUri.LangUri.of(
  typeof window !== 'undefined' ? window.location.href : ''
);

export const APP_URL = 'https://app.adjust.com/v8wodbh_owm7xlg';

export const USER_LOGIN = '/accounts/login';
export const USER_REGISTER = '/accounts/register';
export const USER_LOGIN_PATH = langUri.generatePath(USER_LOGIN);
export const USER_REGISTER_PATH = langUri.generatePath(USER_REGISTER);

export const pathWithRedirectAfterHere = (path: string, location: string) =>
  `${path}?redirect_after=${encodeURIComponent(location)}`;
